import SimpleTable from './component';
import Header from './Header';
import Body from './Body';
import Row from './Row';
import Cell from './Cell';

SimpleTable.Header = Header;
SimpleTable.Body = Body;
SimpleTable.Row = Row;
SimpleTable.Cell = Cell;

export default SimpleTable;



// WEBPACK FOOTER //
// ./components/SimpleTable/index.js